"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SharedStore_1 = __importDefault(require("./SharedStore"));
var ScrollStore_1 = __importDefault(require("./ScrollStore"));
var ExampleStore_1 = __importDefault(require("./ExampleStore"));
var OfferStore_1 = __importDefault(require("./OfferStore"));
var AuthStore_1 = __importDefault(require("./AuthStore"));
var rootStore = {
    sharedStore: SharedStore_1.default,
    scrollStore: ScrollStore_1.default,
    exampleStore: ExampleStore_1.default,
    offerStore: OfferStore_1.default,
    authStore: AuthStore_1.default
};
exports.default = rootStore;
